<script setup>
  import { PayrollHelper } from '@/utils/payroll-helper';
import CurrencyInput from '../shared/CurrencyInput.vue';
</script>

<template>
    <tr :class="{'' : payment.active}">
        <td class="payroll-table-td">{{ payment.sequence }}</td>
        <td class="payroll-table-td">{{ new Date(payment.date).toLocaleDateString('default', { month: 'short', year: 'numeric' }) }}</td>
        <td class="payroll-table-td">
          <span v-if="!edit">{{ getCurrency(payment.value) }}</span>
          <CurrencyInput
            v-if="edit"
            v-model="value"
            @change="updateValue"
            :options="{ currency: 'BRL' }"
          />
        </td>
        <td class="payroll-table-td">{{ getCurrency(fgts) }}</td>
        <td class="payroll-table-td">{{ getCurrency(trView) }}</td>
        <td class="payroll-table-td">{{ getCurrency(selicView) }}</td>
        <td class="payroll-table-td">{{ getCurrency(poupanca) }}</td>
        <td class="payroll-table-td">{{ getCurrency(totalValue) }}</td>
    </tr>
</template>

<script>

export default {
  props: ['payment', 'edit', 'index'],
  data() {
    return {
      honorary: 0,
      value: this.payment.value
    }
  },
  computed: {
    fgts() {
        return this.value * 0.08;
    },
    tr() {
        return this.fgts + (this.fgts * this.payment.tr);
    },
    selic() {
        return this.tr + (this.tr * this.payment.selic);
    },
    poupanca() {
        return this.selic * this.payment.poupanca;
    },
    totalValue() {
        return this.selic + (this.selic * this.payment.poupanca);
    },
    trView() {
      return (this.fgts * this.payment.tr);
    },
    selicView() {
      return (this.fgts * this.payment.selic);
    }
  },
  methods: {
    getCurrency(value) {
      if (value === null || isNaN(value)) return '';
      return value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
    updateValue(val) {
      if (typeof(val) != 'number') return;

      PayrollHelper.updatePaymentValue(this.value, this.index);
    }
  }
}
</script>

<style>
    td.payroll-table-td {
        font-size: 14px;
        vertical-align: middle;
    }
</style>